import React from 'react';
import PropTypes from 'prop-types';

const Phase2ResidenceRules = ({
  data,
  signatureData,
  staffSignatureData,
  currentDate,
}) => {

   const name = `${data.personalContact.firstName} ${data.personalContact.lastName}`
  // Rules data
  const generalRules = [
    "Clients are always subject to random urinalysis and breathalyzers as well as body and personal effect searches.",
    "If the client has an authorized work or volunteer commitment, curfew is 11:00 PM on weekdays and 1:00 AM on weekends. All clients are expected to make curfew on time or there will be consequences. First offense, client will have an early curfew 9:00 PM, second offense, early curfew 6:30 PM and must be up and out of bed by 8:00 AM, third offense client may be asked to leave the residence. Clients may not leave Celebration Pointe property until 5:00am Monday-Sunday unless prior approved.",
    "Clients are expected to attend at least four 12 Step meetings per week. Clients will receive a meeting sheet that must be signed by chairperson during each off-property meeting and must be turned in during the residential house meeting each week.",
    "Clients' rooms and personal belongings may be searched at any time with the client not present.",
    "Clients may REQUEST overnights. All requests MUST be made at least 48 hours in advance and must be approved and signed off by the housing and client care manager.",
    "Legacy is NOT responsible for any lost or damaged personal belongings at the residence. Any clients who do not secure their medications in the locker provided can and will be asked to leave the property at the Clinical Director's discretion.",
    "Clients are strongly suggested to find employment between the hours of 10:00 a.m. to 4:00 p.m. Monday through Friday. This time is also to be used for attending meetings.",
    "Clients are to attend a mandatory house meeting on Tuesday night at 9:30 PM.",
    "Clients are expected to be employed. You have 14 days to find employment or may be asked to leave the residence at the Clinical Director's discretion.",
    "Client will maintain personal hygiene, washing of clothes, and general tidiness.",
    "Client's personal area/bedroom must be clean, and bed made properly every morning before leaving the residence, and personal items are to be stored properly.",
    "A house chore list will be assigned weekly, and each client is to complete their chore daily before they leave for group or work.",
    "Clients are to participate in mandatory general house cleaning Sundays at 10:00 AM.",
    "Clients are to be fully clothed in all common areas (shorts and shirts).",
    "No loud music is permitted.",
    "No sleeping on couches.",
    "Clients are not permitted in anyone else's room without permission.",
    "No eating or drinking of others' food.",
    "Clients are not to lend or borrow others' items or money.",
    "The use of tobacco or e-cigarette product use is prohibited inside the residences.",
    "If clients receive mail or packages, it will be searched by staff.",
    "Clients must notify a house manager if family members are visiting and plan to spend time at the residence.",
    "Any time an IOP client, living on our property, purchases a vehicle the client must provide copies of a valid driver's license, registration and insurance prior to the vehicle going over to housing.",
    "Any client residing at Celebration Point is consenting for them to have a photo of their face, their first name and first letter of their last name as well as their unit number provided to Celebration Point's leasing office.",
    "Client has been oriented to the location of Narcan and how to administer in the event of an emergency."
  ];

  const absoluteRules = [
    "Absolutely no drug or alcohol use, and no drugs or alcohol on property.",
    "No sharing/abusing prescribed or over-the-counter medications.",
    "No medications or supplements of any kind on your person. Medications will be collected, counted, documented, held in the house safe, and distributed by the staff for the entire time the client is living at the residence.",
    "No substances containing alcohol (including mouthwash and hand sanitizer) or fermented beverages of any kind; and no pre-workout supplements, fat burners, prohormones, steroids or kava are allowed on property.",
    "No acts or threats of violence.",
    "No bullying, intimidation, verbal abuse, or emotional abuse.",
    "No weapons.",
    "No stealing.",
    "No gambling, or going to casinos, strip clubs, or bars (alcohol, hookah, or kava).",
    "No women allowed on property without prior approval at any time.",
    "No sexual activity.",
    "No pornographic materials.",
    "No destruction of property. Client will be billed for damages incurred.",
    "No racism, sexism, ableism, religious, spiritual, and/or any other discrimination."
  ];

  const celebrationRules = [
    "No fishing at the lake at any time in Celebration Pointe",
    "Vehicles are granted approval once you get to IOP level of care – Must speak to therapist and housing team and once approved you are expected to provide – Registration, license, insurance – The vehicle must be searched upon entry",
    "After 10pm we must implement 'Quiet time' to eliminate disturbances to neighbors (No loud music, banging of doors, TVs, or cleaning)",
    "All cigarette butts must be placed in ash trays (Absolutely never thrown over the balcony)",
    "No dishes in the sink and beds must be made",
    "Clients can leave their apartments after 6am unless schedule has been approved by therapist",
    "4 mandatory meetings per week – sheet must be turned into the therapist each Monday",
    "Garbage schedule – Sunday through Thursday and it can never be overflowing; please place in front of apartment door after 5pm",
    "Medication must be stored in instructed area (Bottom plastic drawer)",
    "Gate code will be provided upon transition (Absolutely no forced entry)",
    "No use of pool or gym in Celebration Pointe",
    "Rental office is for Legacy staff only – any maintenance requests please contact staff",
    "No mail or packages can be shipped/mailed to the apartments (All mail must go through Clinical address)",
    "LIVING AT CELEBRATION POINTE IS A PRIVILEGE AND ANY VIOLATIONS OR DISTURBANCES CAN AND WILL BE GROUNDS FOR IMMEDIATE DISCHARGE.",
    "DISCLOSURE OF YOUR PRESENCE IN LEGACY HEALING CENTER MARGATE TREATMENT FACILITY OR HOUSING WITH ANYONE (IN OR OUTSIDE OF OUR PROGRAM) IS GROUNDS FOR IMMEDIATE DISMISSAL AS IT IS A VIOLATION TO DISCLOSE ANOTHER PERSON'S PRESENCE IN TREATMENT."
  ];

  return (
    <div
      style={{
        fontFamily: "Arial",
        padding: "20px",
        maxWidth: "800px",
        margin: "0 auto",
        lineHeight: "1.2",
        height: "3600px",
        fontSize: "18px"
      }}
    >
      {/* Title */}
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h2 style={{
          fontFamily: 'Arial',
          fontSize: '14pt',
          fontWeight: 'bold',
          paddingBottom: '5px',
          borderBottom: '2px solid black',
          display: 'inline-block'
        }}>
    Phase 2 Residence Rules
        </h2>
      </div>
      

      {/* Introduction */}
      <div style={{ marginBottom: '20px' }}>
        <p style={{ marginBottom: '10px' }}>
          Clients must always follow rules and regulations. Failure to comply will include consequences up to and including dismissal from recovery residence.
        </p>
        <p style={{ marginBottom: '10px' }}>
          I, {name || "________________________"}, acknowledge that I am not a resident of any of Legacy Healing Center Margate, LLC properties. I further understand that I am a temporary guest with no rights to residency. I am not to use the unit addresses for personal mail, packages or for use on my state identification card.
        </p>
        <p>
          I,{name || "________________________"}, understand that it is mandatory that I provide a urinalysis and breathalyzer sample within 45 minutes that it is requested by Legacy Healing Center Margate, LLC staff. I further acknowledge that refusing to provide a UA/BA within that time will be considered as a refusal to comply. Refusal or a positive sample will require that I follow all recommendations for immediate placement.
        </p>
      </div>

      {/* General Residence Rules */}
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{
          fontSize: '12pt',
          fontWeight: 'bold',
          marginBottom: '10px'
        }}>
          General Residence Rules
        </h2>
        <ol style={{
          paddingLeft: '20px',
          listStyleType: 'none',
          counterReset: 'rule-counter'
        }}>
          {generalRules.map((rule, index) => (
            <li key={`general-${index}`} style={{
              marginBottom: '10px',
              counterIncrement: 'rule-counter',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: '-20px',
                fontWeight: 'bold'
              }}>
                {index + 1}.
              </span>
              <span style={{ marginLeft: '10px' }}>{rule}</span>
            </li>
          ))}
        </ol>
      </section>

      {/* Absolute Residence Rules */}
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{
          fontSize: '14pt',
       
          marginBottom: '10px',
          textAlign:'center'

        }}>
          Absolute Residence Rules 
        </h2>
        <h2 style={{
          fontSize: '14pt',
          fontWeight: 'bold',
          marginBottom: '10px',
          textAlign:'center'

        }}>
        No infractions allowed
        </h2>
        <ol style={{
          paddingLeft: '20px',
          listStyleType: 'none',
          counterReset: 'absolute-counter'
        }}>
          {absoluteRules.map((rule, index) => (
            <li key={`absolute-${index}`} style={{
              marginBottom: '10px',
              counterIncrement: 'absolute-counter',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: '-20px',
                fontWeight: 'bold'
              }}>
                {index + 1}.
              </span>
              <span style={{ marginLeft: '10px' }}>{rule}</span>
            </li>
          ))}
        </ol>
      </section>
      <p style={{fontWeight:'bold', fontSize:'16px', textAlign:'center'}}>Clients must always follow rules and regulations. Failure to comply will include consequences up to and including dismissal from recovery residence.</p>

      {/* Celebration Rules */}
      <section style={{ marginBottom: '30px' }}>
        <h2 style={{
          fontSize: '12pt',
          fontWeight: 'bold',
          marginBottom: '10px'
        }}>
          CELEBRATION RULES – STEP DOWN
        </h2>
        <ul style={{
          paddingLeft: '20px',
          listStyleType: 'none'
        }}>
          {celebrationRules.map((rule, index) => (
            <li key={`celebration-${index}`} style={{
              marginBottom: '10px',
              position: 'relative'
            }}>
              <span style={{
                position: 'absolute',
                left: '-20px'
              }}>
                •
              </span>
              <span style={{ marginLeft: '10px' }}>{rule}</span>
            </li>
          ))}
        </ul>
      </section>

      <div
        style={{
          marginTop: "30px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{ textAlign: "center", flex: 1 }}>
          <div style={{ marginBottom: "30px" }}>
            <img
              src={signatureData || ""}
              alt="Client Signature"
              style={{
                width: "200px",
                height: "70px",
                borderBottom: "1px solid black",
              }}
            />
            <p>
              <span>Client Signature:</span>
            </p>
          </div>
        </div>
        <div style={{ textAlign: "center", flex: 1 }}>
          <div style={{ marginBottom: "20px", marginTop: signatureData ? "60px" : "0", }}>
            {/* {!currentDate && ( */}
            <div>{currentDate}</div>
            <div
              style={{
                borderBottom: "1px solid black",
                width: "300px",
                // height: "30px",
              }}
            ></div>
            {/* )} */}
            <p>Date:</p>
          </div>
        </div>
      </div>

    </div>
  );
};

Phase2ResidenceRules.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }).isRequired
};

export default Phase2ResidenceRules;